/* atlas-tfa (loja Shopify): pixel Taboola das 3 contas (2107815, 2107816, 2107817),
   eventos Cart (add to cart) e IC (inicio de checkout) e o click id (tblci) gravado
   no carrinho para o pedido chegar com o id (postback S2S do Purchase). */
(function () {
  'use strict';

  var IDS = [2107815, 2107816, 2107817];
  var KEY = 'atl_tblci';

  /* ---------- 1) base: page_view nas 3 contas ---------- */
  window._tfa = window._tfa || [];
  for (var i = 0; i < IDS.length; i++) {
    window._tfa.push({ notify: 'event', name: 'page_view', id: IDS[i] });
  }
  for (var j = 0; j < IDS.length; j++) {
    (function (id) {
      var elId = 'tb_tfa_script_' + id;
      if (document.getElementById(elId)) { return; }
      !function (t, f, a, x) {
        if (!document.getElementById(x)) {
          t.async = 1; t.src = a; t.id = x; f.parentNode.insertBefore(t, f);
        }
      }(document.createElement('script'), document.getElementsByTagName('script')[0],
        '//cdn.taboola.com/libtrc/unip/' + id + '/tfa.js', elId);
    })(IDS[j]);
  }

  /* ---------- 2) evento para as 3 contas ---------- */
  function fire(name) {
    for (var k = 0; k < IDS.length; k++) {
      window._tfa.push({ notify: 'event', name: name, id: IDS[k] });
    }
  }

  /* ---------- 3) click id do anuncio (tblci) ---------- */
  function setCookie(name, val) {
    try { document.cookie = name + '=' + encodeURIComponent(val) + ';path=/;max-age=2592000;SameSite=Lax'; } catch (e) {}
  }
  function getCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }
  function grab() {
    var v = '';
    try { v = new URLSearchParams(location.search).get('tblci') || ''; } catch (e) {}
    if (v) {
      try { localStorage.setItem(KEY, v); } catch (e) {}
      setCookie('atl_tblci', v);
      setCookie('tblci', v);
      return v;
    }
    return getCookie('atl_tblci') || (function () { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } })();
  }
  var CID = grab();

  /* grava o click id como atributo do carrinho: chega no pedido como note_attributes.tblci */
  function syncAttr() {
    if (!CID) { return; }
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { tblci: CID } }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- 4) Cart (add to cart) e IC (inicio de checkout) ---------- */
  var SEL_ADD = 'button[name="add"], form[action*="/cart/add"] button[type="submit"], [data-add-to-cart], .product-form__submit, button.quick-add__submit';
  var SEL_IC = 'button[name="checkout"], a[href*="/checkout"], .cart__checkout-button, [data-shopify="payment-button"], .shopify-payment-button__button';
  var SEL_ADD_SOFT = 'shopify-buy-it-now-button, .shopify-payment-button';

  function marcar(el, tag) {
    if (!el || el.getAttribute('data-atl-tfa')) { return false; }
    el.setAttribute('data-atl-tfa', tag);
    return true;
  }

  function bind() {
    var adds = document.querySelectorAll(SEL_ADD);
    for (var a = 0; a < adds.length; a++) {
      if (!marcar(adds[a], 'add')) { continue; }
      adds[a].addEventListener('click', function () { syncAttr(); fire('Cart'); }, true);
    }

    var ics = document.querySelectorAll(SEL_IC);
    for (var b = 0; b < ics.length; b++) {
      if (!marcar(ics[b], 'ic')) { continue; }
      ics[b].addEventListener('click', function () { syncAttr(); fire('IC'); }, true);
    }

    var soft = document.querySelectorAll(SEL_ADD_SOFT);
    for (var c = 0; c < soft.length; c++) {
      if (!marcar(soft[c], 'buynow')) { continue; }
      soft[c].addEventListener('click', function () { syncAttr(); fire('Cart'); fire('IC'); }, true);
    }
  }

  function start() {
    bind();
    syncAttr();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  setTimeout(start, 1200);
  setTimeout(start, 3000);
  setTimeout(start, 6000);
})();
